export const Logo = ({ size = 44 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 112"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="logo-mark"
    aria-label="Peluso Service"
  >
    <rect width="100" height="100" fill="#FFD500" />
    <path
      d="M8 22V8h16M76 8h16v14M92 78v14H76M24 92H8V78"
      stroke="#0A0A0B"
      strokeWidth="6"
      fill="none"
    />
    <text x="50" y="40" fontFamily="'Barlow Condensed', sans-serif" fontSize="26" fontWeight="900" textAnchor="middle" fill="#0A0A0B">PE</text>
    <text x="50" y="66" fontFamily="'Barlow Condensed', sans-serif" fontSize="26" fontWeight="900" textAnchor="middle" fill="#0A0A0B">LU</text>
    <text x="50" y="90" fontFamily="'Barlow Condensed', sans-serif" fontSize="24" fontWeight="900" textAnchor="middle" fill="#0A0A0B">SO</text>
    <rect y="100" width="100" height="12" fill="#0A0A0B" />
    <text x="50" y="109" fontFamily="'JetBrains Mono', monospace" fontSize="8" fontWeight="700" letterSpacing="3" textAnchor="middle" fill="#FFD500">SERVICE</text>
  </svg>
);
